import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { InterventionTimer } from '../../components/manutenzione/InterventionTimer';
import { ResolvableReportCard } from '../../components/manutenzione/ResolvableReportCard';
// Mock data - SOLO oggetto rotto (manutenzione)
const mockReport = {
  id: '1',
  type: 'Oggetto Rotto',
  emoji: '🔧',
  description: 'Il rubinetto del lavandino perde acqua continuamente. La perdita sembra provenire dalla base del rubinetto. Ho provato a stringere ma continua a perdere.',
  photos: ['https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=600&q=80', 'https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&w=600&q=80', 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?auto=format&fit=crop&w=600&q=80'],
  isResolved: false
};
export function InterventionInProgressPage() {
  const navigate = useNavigate();
  const [startTime] = useState(new Date());
  const [report, setReport] = useState(mockReport);
  const [notes, setNotes] = useState('');
  // Sempre espansa per singola segnalazione
  const [isExpanded] = useState(true);
  const toggleResolved = () => {
    setReport(prev => ({
      ...prev,
      isResolved: !prev.isResolved
    }));
  };
  const handleComplete = () => {
    if (report.isResolved) {
      navigate('/manutenzione/complete/property-123');
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-1488">
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 pb-32" data-id="element-1489">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1490">
          <div className="flex items-center gap-2 mb-3" data-id="element-1491">
            <h1 className="text-4xl font-bold text-navy" data-id="element-1492">
              Via Roma 123, Appartamento 4B
            </h1>
          </div>
          <span className="inline-block px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-base font-semibold border border-blue-200" data-id="element-1493">
            Intervento in corso
          </span>
        </div>

        {/* Timer */}
        <div className="mb-12" data-id="element-1494">
          <InterventionTimer startTime={startTime} data-id="element-1495" />
        </div>

        {/* Segnalazione da risolvere */}
        <div className="mb-12" data-id="element-1496">
          <h2 className="text-xl font-bold text-navy mb-6" data-id="element-1497">
            Segnalazione da risolvere
          </h2>

          <ResolvableReportCard report={report} isExpanded={isExpanded} onToggle={() => {}} // No-op, sempre espansa
        onResolveToggle={toggleResolved} data-id="element-1498" />

          {/* Completed Message */}
          {report.isResolved && <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6 bg-green-50 border border-green-200 rounded-xl p-6" data-id="element-1499">
              <div className="flex items-center gap-3" data-id="element-1500">
                <CheckCircle className="w-7 h-7 text-green-600" data-id="element-1501" />
                <p className="text-base font-semibold text-green-900" data-id="element-1502">
                  ✓ Segnalazione completata
                </p>
              </div>
            </motion.div>}
        </div>

        {/* Note Intervento */}
        <div className="mb-12" data-id="element-1503">
          <label className="block text-base font-semibold text-gray-700 mb-3" data-id="element-1504">
            Note intervento (opzionale)
          </label>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Aggiungi eventuali annotazioni sull'intervento..." rows={4} className="w-full px-5 py-4 text-base bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all resize-none" data-id="element-1505" />
        </div>
      </main>

      {/* Fixed Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 md:p-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-40" data-id="element-1506">
        <div className="max-w-4xl mx-auto" data-id="element-1507">
          <Button onClick={handleComplete} disabled={!report.isResolved} className={`w-full text-lg h-14 ${!report.isResolved ? 'opacity-40 cursor-not-allowed' : ''}`} data-id="element-1508">
            Concludi Intervento
            <CheckCircle className="w-5 h-5 ml-2" data-id="element-1509" />
          </Button>
        </div>
      </div>
    </div>;
}